import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import classNames from 'classnames';
import styles from './ValueBadge.module.scss';

export type ValueBadgeProps = {
  label: string;
  icon?: React.ReactElement;
  badgeStyle?: 'primary' | 'secondary' | 'default' | 'error';
  tooltip?: string | null;
};
export function ValueBadge({
  icon,
  label,
  badgeStyle = 'default',
  tooltip,
}: ValueBadgeProps) {
  return (
    <Tooltip title={tooltip} placement="right" data-testid="value-tooltip">
      <Chip
        icon={icon}
        label={label}
        sx={{ cursor: 'inherit' }}
        size="small"
        variant="outlined"
        data-testid="value-badge"
        className={classNames(styles.valueBadgeChip, {
          [styles.primary]: badgeStyle === 'primary',
          [styles.secondary]: badgeStyle === 'secondary',
          [styles.error]: badgeStyle === 'error',
          [styles.default]: badgeStyle === 'default',
        })}
      />
    </Tooltip>
  );
}
